// @flow
import { Logger } from 'utils/logger'

export const logger = Logger.get('updater')
